var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12"}},[_c('image-uploader',{attrs:{"box-probs":_vm.boxProbs,"label":_vm.$t('profile_image'),"filename":_vm.$t('profile_image'),"subobject":"bom_object","legacy-marker":"profilbild"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }